<template>
  <LayoutSearchFieldVertical>
    <div class="search-field-number-range">
      <form class="search-keyword-field" @submit.prevent="addRange">
        <input
          class="jps-input jps-keyword-input input-number"
          type="number"
          v-model="from"
          :placeholder="placeholder"
          @keyup.prevent.esc="from = null"
        />
        <span>{{ lss('～', '-') }}</span>

        <input
          class="jps-input jps-keyword-input generated-14"
          type="number"
          min="0"
          v-model="to"
          @keyup.prevent.esc="to = null"
        />
        <UiButtonIcon
          class="jps-icon-button generated-21"
          tag="button"
          type="submit"
          icon="mdi/plus-circle"
          icon-size="size-5"
          styled="secondary"
        />
      </form>
    </div>
  </LayoutSearchFieldVertical>
</template>

<script lang="ts" setup>
import { useSearchFieldBase } from '~/components/search/search-field/useBaseSearchField'
import type { SearchFieldBaseProps } from '~/components/search/search-field/useBaseSearchField'

const { lss } = useI18n()

interface Props extends SearchFieldBaseProps {
}
const props = withDefaults(defineProps<Props>(), {
})

const { placeholder } = useSearchFieldBase(props)

const to = ref(null)
const from = ref(null)

const addRange = () => {
  if (from.value === '') from.value = null
  if (to.value === '') to.value = null
  if (from.value == null && to.value == null) return
  let year = {}
  if (from.value != null) year['from'] = '' + from.value
  if (to.value != null) year['to'] = '' + to.value
  props.ss.setRange(props.field.key, [year])
}
</script>

<style lang="scss" scoped>
@use '@/assets/styles/scss/vue' as *;

.generated-14 {
    padding-right: 0.25rem;
    text-align: center;
}

.generated-21 {
  width: 1.25rem;
  height: 1.25rem;
}
</style>
